import React, { useEffect, useState } from "react";

//package import

import { useNavigate } from "react-router-dom";
import { ActionCableProvider } from "react-actioncable-provider";
import { Backdrop, CircularProgress, useTheme } from "@mui/material";

//user import

import { AdminLayout } from "../../layouts";
import { admin_Context } from "../../context";
import { ADMIN_API_ULRS, API_WS_ROOT } from "../../Services/Routes/API";
import { RoutesUrls } from "../../Services/Routes/APP";
import { headersPost } from "../../Services/API";
import { StorageKeys } from "../../Services/Storage";

//portal

const AdminPortal = (props) => {
	//hooks

	const Provider = admin_Context.Provider;
	const navigate = useNavigate();
	const theme = useTheme();

	//states
	const [open, setOpen] = useState(false);
	const [categories, setCategories] = useState([]);

	const token = localStorage.getItem(StorageKeys?.token);

	//life cycle hook

	useEffect(() => {
		getCategories();
	}, []);

	//get provinces

	const getCategories = () => {
		const data = {
			page: "all",
		};
		setOpen(true);

		headersPost(ADMIN_API_ULRS.GET_ALL_CATEGORIES, data)
			.then((res) => {
				setOpen(false);
				if (res?.status === 200 && res?.data?.success) {
					setCategories(res?.data?.categories);
				} else {
		      // setAlertOpen(true);
		      // setAlertMsg(response?.data?.message);
		      // setAlertIcon("warning");
				}
			})
			.catch((err) => {
				setOpen(false);
				const { response } = err;
				if (response?.status === 401) {
					localStorage.clear();
					navigate(RoutesUrls?.root);
				} else {
          // setAlertOpen(true);
          // setAlertMsg(response?.statusText);
          // setAlertIcon("error");
				}
			});
	};

	//render

	return (
		<Provider
			value={{
				categories: categories,
				user: { ...token },
			}}
		>
			<ActionCableProvider url={API_WS_ROOT + `?token=${token}`}>
				<AdminLayout {...props} />
			</ActionCableProvider>

			<Backdrop
				sx={{
					zIndex: theme.zIndex.drawer + 1,
					color: theme.palette.primary.main,
				}}
				open={open}
			>
				<CircularProgress color="inherit" />
			</Backdrop>
		</Provider>
	);
};

export default AdminPortal;
